module.exports = __webpack_public_path__ + "img/AIX爱熙医疗.dd678d1.png";